import { FaqAccordion } from '../../../../FaqSection/components/FaqAccordion/FaqAccordion';

type AccordionItem = {
  title: string;
  description: string;
};

type AccordionProps = {
  items?: Array<AccordionItem>;
  isTermsAndConditions?: boolean;
  isCallToAction?: boolean;
};

/**
 * Accordion component for landing pages
 *
 * Displays a list of FAQ items in an accordion format with conditional styling
 * based on the presence of terms and conditions and call-to-action elements.
 *
 * @param items - Array of accordion items with title and description
 * @param isTermsAndConditions - Boolean indicating if terms and conditions are present
 * @param isCallToAction - Boolean indicating if call-to-action is present
 */
function Accordion({ items, isTermsAndConditions, isCallToAction }: AccordionProps): React.JSX.Element | null {
  if (!items?.length) {
    return null;
  }

  const sectionClassName = `ll-container-inner flex flex-col items-start ${!isTermsAndConditions && isCallToAction ? 'pb-16 md:pb-0' : ''}`;

  return (
    <section className={sectionClassName} data-testid="accordion">
      <div className="w-full" data-track-container="FAQs">
        <FaqAccordion
          items={items.map(item => ({
            question: item.title,
            answer: item.description,
          }))}
        />
      </div>
    </section>
  );
}

export { Accordion, type AccordionProps };
